import type { Story } from '@/store/story-types'

export const FOOD_DELIVERY_NEW3_STORY: Story = {
  id: 'food-delivery-new3',
  name: 'NomNom — Food Delivery',
  narrative: 'A vibrant food delivery app with diverse cuisines, fast ordering, and real-time tracking. Users browse restaurants, add meals to cart, and place orders.',
  goals: ['Browse diverse cuisine categories', 'View restaurant menus and dishes', 'Add items to cart with customization', 'Place order and track delivery'],
  lifecycle: 'ready',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'completed', elementCount: 7, linkedPageId: 'home', description: 'Landing page with restaurant listings and cuisine categories' },
    { id: 'pg-detail', title: 'Restaurant Detail', order: 1, status: 'completed', elementCount: 5, linkedPageId: 'product-detail', description: 'Restaurant menu with dishes and prices' },
    { id: 'pg-cart', title: 'Cart', order: 2, status: 'completed', elementCount: 4, linkedPageId: 'cart', description: 'Order summary with item list and total' },
    { id: 'pg-checkout', title: 'Checkout', order: 3, status: 'completed', elementCount: 4, linkedPageId: 'checkout', description: 'Delivery address and payment form' },
  ],
  bddScenarios: [
    {
      id: 'bdd-1', name: 'Browse Restaurants',
      description: 'User browses available restaurants',
      steps: [
        { type: 'given', text: 'the user opens the food delivery app' },
        { type: 'when', text: 'the home page loads' },
        { type: 'then', text: 'restaurant cards with cuisines and ratings are displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2', name: 'View Menu',
      description: 'User views a restaurant menu',
      steps: [
        { type: 'given', text: 'the user is browsing restaurants', linkedPageId: 'home' },
        { type: 'when', text: 'they select a restaurant' },
        { type: 'then', text: 'the menu with dishes, prices, and descriptions is shown', linkedPageId: 'product-detail' },
      ],
    },
    {
      id: 'bdd-3', name: 'Add to Order',
      description: 'User adds a dish to the order',
      steps: [
        { type: 'given', text: 'the user is viewing a menu', linkedPageId: 'product-detail' },
        { type: 'when', text: 'they tap Add to Order on a dish' },
        { type: 'then', text: 'the dish is added to cart and total updates', linkedFlowId: 'addToCart' },
      ],
    },
    {
      id: 'bdd-4', name: 'Place Order',
      description: 'User places the delivery order',
      steps: [
        { type: 'given', text: 'the user has items in cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they enter delivery details and confirm order' },
        { type: 'then', text: 'order is placed and confirmation is displayed', linkedPageId: 'checkout' },
      ],
    },
  ],
}
